import React from "react"
import {useTemplatedComponent} from "@next/templating"
import {MANIFEST} from "@manifest/header"
import {Icons, Link} from "../../models/secondary-nav"

import connect from "./connect"

export type BurgerSecondaryNavSectionProps = {
    title?: string | null
    englishTitle?: string | null | undefined
    englishDepartment: string | null | undefined
    blockLinks?: Link[]
    department: string
    isImagePlaceholderEnabled: boolean
    icons: Icons[] | undefined
    realm: string
    isFirstSection: boolean
    testingVariant?: string | null
    siteUrl: string
    templating: {
        mainTemplate: string
        fallbackTemplate: string
    }
    iconsVersionPath: string
    variant: string
    text: any
}

export const BurgerSecondaryNavSection = ({
    title,
    englishTitle,
    blockLinks,
    department,
    englishDepartment,
    isImagePlaceholderEnabled,
    icons,
    realm,
    isFirstSection = false,
    testingVariant,
    siteUrl,
    templating,
    iconsVersionPath,
    variant,
    text,
}: BurgerSecondaryNavSectionProps) => {
    const TemplatedComponent = useTemplatedComponent(templating, MANIFEST)
    return (
        <TemplatedComponent
            title={title}
            englishTitle={englishTitle}
            blockLinks={blockLinks}
            department={department}
            englishDepartment={englishDepartment}
            isImagePlaceholderEnabled={isImagePlaceholderEnabled}
            icons={icons}
            realm={realm}
            isFirstSection={isFirstSection}
            testingVariant={testingVariant}
            siteUrl={siteUrl}
            variant={variant}
            iconsVersionPath={iconsVersionPath}
            text={text}
        />
    )
}

export default connect(BurgerSecondaryNavSection)
